const Jumper = [
	'[Hook]',
	'I wish you would step back from that ledge my friend',
	"You could cut ties with all the lies that you've been livin in, A-and",
	'if you do not want to see me again',
	'I will Under-sta---i-a---i-and',
	'I will under-sta---i-a---i-and',
	'',
	'[Verse 1]',
	'The angry boy, a bit too insane,',
	'icing over a secret pain,',
	"You know you don't belong,",
	"You're the first to fight, you're way to loud,",
	"You're the flash of light, on a burial shroud",
	"I know something's wrong",
	'Well everyone I know has got a reason, to say, put the past away',
	'',
	'[Hook]',
	'I wish you would step back from that ledge my friend',
	"You could cut ties with all the lies, that you've been livin in, a-and",
	'if you do not want to see me again,',
	'I would under-sta---i-a---i-and',
	'I would Under-sta-a-a---i-a---i-and',
	'',
	'[Verse 2]',
	"Well he's on the table and he's gone ta code,",
	'And I do not think an one know what they are,',
	'doing here-er',
	"And your friends have left, you've been dismissed,",
	'I never thougt it would come to this, and',
	'I, I want you to know-o',
	"Everyone's got to face down the demons, maybe today,we can put the past away",
	'',
	'[Hook]',
	'I wish you would step back from that ledge my friend',
	"you could cut ties with all the lies that you've been livin, A-and",
	'if you do not want to see me again,',
	'I would under-sta---i-a---i-and',
	'I would under-sta---i-a---i-and',
	'I would under-sta---i-a---i-a-and',
];

export default Jumper;
